export default __webpack_public_path__ + "b1e1595cff56c283d722339b2a4d4c45.png";